import { Spin } from "antd";
import styled from "styled-components";

export const SpinStyled = styled(Spin)`
  width: 100%;
  padding-top: 16px;
`;
